import De from "@/nav-localized/messages/de.json";
import En from "@/nav-localized/messages/en.json";
import Es from "@/nav-localized/messages/es.json";
import Fr from "@/nav-localized/messages/fr.json";
// import KoKr from '../../messages/ko-kr.json';
import Ru from "@/nav-localized/messages/ru.json";
// import Tr from "@/nav-localized/messages/tr.json";
import Pt from "@/nav-localized/messages/pt.json";
import UkUa from "@/nav-localized/messages/uk-ua.json";
import Vi from "@/nav-localized/messages/vi.json";
// import ZhTw from '../../messages/zh-tw.json';
import Ar from "@/nav-localized/messages/ar.json";
const Languages = {
  en: En,
  es: Es,
  de: De,
  fr: Fr,
  // tr: Tr,
  ru: Ru,
  "uk-ua": UkUa,
  vi: Vi,
  pt: Pt,
  ar: Ar
};

export type LanguagesType = keyof typeof Languages;

export type MessagesType = keyof typeof En.header;

export { Languages };

export type Theme = "light" | "dark";

export interface UsuallyResponse<T> {
  code: number;
  data: T;
  msg: string;
}
